module.exports = "<div class=\"input__container\">\n\t<input class=\"form__input\" [(ngModel)]=\"_costCenter\" maxlength=\"255\"/>\n</div>\n<div class=\"cc-button__container\">\n\t<button type=\"button\" class=\"button--bright-blue\" (click)=\"saveCostCenter.emit(_costCenter)\">Speichern</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/cost-center/cost-center.presentation.html
// module id = Mw3Y
// module chunks = 12